<template>
  <div>
    <!-- 顶部欢迎及注册登录按钮导航 -->
    <header-top />
    <!-- 顶部公司logo及导航栏 -->
    <logo-head></logo-head>
    <!-- 导航栏 -->
    <nav-head></nav-head>
    <!--查询容器-->
    <div class="query-container">
      <el-form :model="queryFrom" label-width="100px">
        <el-form-item label="综合搜索" >
          <el-select v-model="queryFrom.integrated_type">
            <el-option v-for="item in integrated_type_arr" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-input v-model="queryFrom.integrated_keyword" style="margin-left: 5px; width: 300px" placeholder="请输入关键字"></el-input>
        </el-form-item>
        <el-form-item label="内容">
          <el-select v-model="queryFrom.content_type_1">
            <el-option v-for="item in integrated_type_arr" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-input v-model="queryFrom.content_keyword_1" style="margin-left: 5px; width: 300px" placeholder="请输入关键字"></el-input>
        </el-form-item>
        <el-form-item label=" ">
          <el-select v-model="queryFrom.content_type_2">
            <el-option v-for="item in integrated_type_arr" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-input v-model="queryFrom.content_keyword_2" style="margin-left: 5px; width: 300px" placeholder="请输入关键字"></el-input>
        </el-form-item>
        <el-form-item label=" ">
          <el-select v-model="queryFrom.content_type_3">
            <el-option v-for="item in integrated_type_arr" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-input v-model="queryFrom.content_keyword_3" style="margin-left: 5px; width: 300px" placeholder="请输入关键字"></el-input>
        </el-form-item>
        <el-form-item label="单位/人">
          <el-select v-model="queryFrom.unit_or_person_1">
            <el-option v-for="item in unit_or_person_type_arr" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-input v-model="queryFrom.unit_or_person_keyword_1" style="margin-left: 5px; width: 300px" placeholder="请输入关键字"></el-input>
        </el-form-item>
        <el-form-item label=" ">
          <el-select v-model="queryFrom.unit_or_person_2">
            <el-option v-for="item in unit_or_person_type_arr2" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-input v-model="queryFrom.unit_or_person_keyword_2" style="margin-left: 5px; width: 300px" placeholder="请输入关键字"></el-input>
        </el-form-item>
        <el-form-item label="号码">
          <el-select v-model="queryFrom.number_query_type_1">
            <el-option v-for="item in number_query_type_arr" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-input v-model="queryFrom.number_query_keyword_1" style="margin-left: 5px; width: 300px"placeholder="请输入关键字"></el-input>
        </el-form-item>
        <el-form-item label=" ">
          <el-select v-model="queryFrom.number_query_type_2">
            <el-option v-for="item in number_query_type_arr" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-input v-model="queryFrom.number_query_keyword_2" style="margin-left: 5px; width: 300px"placeholder="请输入关键字"></el-input>
        </el-form-item>
        <el-form-item label="日期">
          <el-select v-model="queryFrom.date_query_type_1">
            <el-option v-for="item in date_type_arr" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-input v-model="queryFrom.date_query_keyword_1" style="margin-left: 5px; width: 300px"placeholder="请输入关键字"></el-input>
        </el-form-item>
        <el-form-item label=" ">
          <el-select v-model="queryFrom.date_query_type_2">
            <el-option v-for="item in date_type_arr" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-input v-model="queryFrom.date_query_keyword_2" style="margin-left: 5px; width: 300px"placeholder="请输入关键字"></el-input>
        </el-form-item>
        <el-form-item label="分类">
          <el-select v-model="queryFrom.classification_type">
            <el-option v-for="item in classify_type_arr" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-input v-model="queryFrom.classification_keyword" style="margin-left: 5px; width: 300px" placeholder="请输入关键字"></el-input>
        </el-form-item>
        <!--代理所/人-->
        <el-form-item label="代理所/人">
          <el-select v-model="queryFrom.agent_type">
            <el-option v-for="item in agent_type_arr" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-input v-model="queryFrom.agent_keyword" style="margin-left: 5px; width: 300px" placeholder="请输入关键字"></el-input>
        </el-form-item>
        <!--同族/引用-->
        <el-form-item label="同族/引用">
          <el-select v-model="queryFrom.same_family_type">
            <el-option v-for="item in same_family_type_arr" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-input v-model="queryFrom.same_family_keyword" style="margin-left: 5px; width: 300px" placeholder="请输入关键字"></el-input>
        </el-form-item>
        <el-form-item label=" ">
          <el-select v-model="queryFrom.same_family2_type">
            <el-option v-for="item in same_family2_type_arr" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-input v-model="queryFrom.same_family2_keyword" style="margin-left: 5px; width: 300px" placeholder="请输入关键字"></el-input>
        </el-form-item>
        <!--优先权/PCT-->
        <el-form-item label="优先权/PCT">
          <el-select v-model="queryFrom.pct_type_1">
            <el-option v-for="item in pct_type_arr" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-input v-model="queryFrom.pct_keyword_1" style="margin-left: 5px; width: 300px" placeholder="请输入关键字"></el-input>
        </el-form-item>
        <el-form-item label=" ">
          <el-select v-model="queryFrom.pct_type_2">
            <el-option v-for="item in pct_type_arr" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-input v-model="queryFrom.pct_keyword_2" style="margin-left: 5px; width: 300px" placeholder="请输入关键字"></el-input>
        </el-form-item>
        <!--法律状态-->
        <el-form-item label="法律状态">
          <el-select v-model="queryFrom.legal_status_type" style="margin-left: 5px;">
            <el-option v-for="item in legal_status_type_arr" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-select v-model="queryFrom.legal_status_keyword" style="margin-left: 5px; width: 300px">
            <el-option v-show="queryFrom.legal_status_type === 'LS'" v-for="item in legal_status_arr" :key="item.value" :label="item.label" :value="item.value"></el-option>
            <el-option v-show="queryFrom.legal_status_type === 'LE'" v-for="item in legal_shijian_arr" :key="item.value" :label="item.label" :value="item.value"></el-option>
            <el-option v-show="queryFrom.legal_status_type === 'LT'" v-for="item in is_sq_arr" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="btn-box">
        <el-button type="primary" @click="getZlList(3)">综合查询</el-button>
        <el-button type="primary" @click="getZlList(1)">专利查询</el-button>
        <el-button type="primary" @click="getZlList(2)">期刊查询</el-button>
        <el-button type="warning" @click="reset">重置</el-button>
      </div>

    </div>

  </div>

</template>

<script>
import LogoHead from "@/components/logoHead/logoWgHead.vue";
import NavHead from "@/components/navHead/navHead.vue";
import HeaderTop from "@/components/headerTop/headerTop.vue";

export default {
  name: 'zlQuery',
  components: {HeaderTop, NavHead, LogoHead},
  data() {
    return {
      queryFrom: {
        // 综合搜索
        integrated_type: null,
        integrated_keyword: null,
        // 内容
        content_type_1: null,
        content_keyword_1: null,
        content_type_2: null,
        content_keyword_2: null,
        content_type_3: null,
        content_keyword_3: null,
        // 单位/人
        unit_or_person_1: null,
        unit_or_person_keyword_1: null,
        unit_or_person_2: null,
        unit_or_person_keyword_2: null,
        // 号码
        number_query_type_1: null,
        number_query_keyword_1: null,
        number_query_type_2: null,
        number_query_keyword_2: null,
        // 日期
        date_query_type_1: null,
        date_query_keyword_1: null,
        date_query_type_2: null,
        date_query_keyword_2: null,
        // 分类
        classification_type: null,
        classification_keyword: null,
        // 代理所/人
        agent_type: null,
        agent_keyword: null,
        // 同族/引用
        same_family_type: null,
        same_family_keyword: null,
        same_family2_type: null,
        same_family2_keyword: null,
        // 优先权/PCT
        pct_type_1: null,
        pct_keyword_1: null,
        pct_type_2: null,
        pct_keyword_2: null,
        // 法律状态
        legal_status_type: null,
        legal_status_keyword: null
      },
      // 综合搜索类型数组
      integrated_type_arr: [
        {
          label: '综合搜索',
          value: 'integratedQuery'
        },
        {
          label: '名称',
          value: 'TI'
        },
        {
          label: '摘要',
          value: 'AB'
        },
        {
          label: '名称+摘要',
          value: 'TI,AB'
        }
      ],
      // 单位/人
      unit_or_person_type_arr: [
        {
          label: '申请人(专利权人)[历史全部]',
          value: 'APALL'
        },
        {
          label: '第一申请人(专利权人)[文献中]',
          value: 'APF_KW'
        },
        {
          label: '第一申请人(专利权人)[当前]',
          value: 'APCF_KW'
        }
      ],
      unit_or_person_type_arr2: [
        {
          label: '发明人[历史全部]',
          value: 'INVALL'
        },
        {
          label: '第一发明人[文献中]',
          value: 'INVF_KW'
        },
        {
          label: '第一发明人[当前]',
          value: 'INVCF_KW'
        }
      ],
      // 号码
      number_query_type_arr: [
        {
          label: '申请号',
          value: 'AN'
        },
        {
          label: '公开(公告)号',
          value: 'PN'
        },
        {
          label: '文献代码',
          value: 'KD'
        },
        {
          label: '优先权号',
          value: 'PR'
        },
        {
          label: 'PCT申请号',
          value: 'PCTAN'
        },
        {
          label: 'PCT公开号',
          value: 'PCTPN'
        },
        {
          label: '引用专利',
          value: 'CIT'
        },
        {
          label: '被引用专利',
          value: 'CITED'
        },
        {
          label: '引用文献[非专利]',
          value: 'CITXML'
        }
      ],
      // 日期
      date_type_arr: [
        {
          label: '申请日',
          value: 'AD'
        },
        {
          label: '公开(公告)日',
          value: 'PD'
        },
        // {
        //   label: '专利到期日',
        //   value: 'authorization_date'
        // },
        {
          label: '优先权日',
          value: 'PRD'
        },
        {
          label: 'PCT申请日',
          value: 'PCTAD'
        },
        {
          label: 'PCT公开日',
          value: 'PCTPD'
        },
        {
          label: '进入国家日',
          value: 'PCTENTRED'
        }
      ],
      //分类
      classify_type_arr: [
        {
          label: '分类号',
          value: 'IPC,CPC'
        },
        {
          label: 'IPC分类号',
          value: 'IPC'
        },
        {
          label: 'IPC主分类号',
          value: 'IPCF'
        },
        {
          label: 'CPC分类号',
          value: 'cpc_invention'
        },
        {
          label: '美国专利分类号[USPC]',
          value: 'UPC'
        },
        {
          label: 'FI分类号',
          value: 'FI'
        },
        {
          label: 'FTERM分类号',
          value: 'FTERM'
        },
        {
          label: '外观设计分类号',
          value: 'IDC'
        },
      ],
      // 代理所/人
      agent_type_arr: [
        {
          label: '专利代理机构',
          value: 'AGC'
        },
        {
          label: '代理人',
          value: 'ATT'
        },
      ],
      // 同族/引用
      same_family_type_arr: [
        {
          label: '同族专利[简]',
          value: 'FAM'
        },
        {
          label: '同族专利[简]数量',
          value: 'FAMCNT'
        }
      ],
      same_family2_type_arr: [
        {
          label: '引用专利',
          value: 'CIT'
        },
        {
          label: '引用专利数量',
          value: 'CITCNT'
        },
        {
          label: '被引用专利',
          value: 'CITED'
        },
        {
          label: '被引用专利数量',
          value: 'CITEDCNT'
        },
        {
          label: '引用文献[非专利]',
          value: 'cited_citations'
        }
      ],
      // 优先权/PCT
      pct_type_arr: [
        {
          label: 'PCT申请号',
          value: 'PCTAN'
        },
        {
          label: 'PCT申请日',
          value: 'PCTAD'
        },
        {
          label: 'PCT公开号',
          value: 'PCTPN'
        },
        {
          label: 'PCT公开日',
          value: 'PCTPD'
        },
        {
          label: '进入国家日',
          value: 'PCTENTRED'
        },
        {
          label: '是否国际申请(PCT)',
          value: 'PCT'
        },
        {
          label: '优先权号',
          value: 'PR'
        },
        {
          label: '优先权日',
          value: 'PRD'
        },
        {
          label: '是否要求优先权',
          value: 'PR-HN'
        }
      ],
      //法律状态
      legal_status_type_arr: [
        {
          label: '法律状态',
          value: 'LS'
        },
        {
          label: '法律事件',
          value: 'LE'
        },
        {
          label: '是否授权',
          value: 'LT'
        }
      ],

      legal_status_arr:[
          {
            label: '公开',
            value: '公开'
          },
          {
            label: '实审',
            value: '实审'
          },
          {
            label: '有权',
            value: '有权'
          },
          {
            label: '避重放弃',
            value: '避重放弃'
          },
          {
            label: '驳回',
            value: '驳回'
          },
          {
            label: '主动放弃',
            value: '主动放弃'
          },
          {
            label: '视为放弃',
            value: '视为放弃'
          },
          {
            label: '视为撤回',
            value: '视为撤回'
          },
          {
            label: '撤回',
            value: '撤回'
          },
          {
            label: '未缴年费',
            value: '未缴年费'
          },
          {
            label: '届满',
            value: '届满'
          },
          {
            label: '终止',
            value: '终止'
          },
          {
            label: '无权',
            value: '无权'
          },
          {
            label: '无权',
            value: '无权'
          }
      ],

      legal_shijian_arr:[
        {
          label: '质押保全',
          value: '质押保全'
        },
        {
          label: '更新',
          value: '更新'
        },
        {
          label: '许可备案',
          value: '许可备案'
        },
        {
          label: '著录变更',
          value: '著录变更'
        },
        {
          label: '权利转移',
          value: '权利转移'
        }
      ],

      is_sq_arr: [
          {
            label: '有权',
            value: '有权'
          },
          {
            label: '无权',
            value: '无权'
          },
          {
            label: '审中',
            value: '审中'
          }
      ]
    }
  },
  mounted() {
    let isLogin = window.sessionStorage.getItem('token')
    if (!isLogin) {
      this.$router.push('/login')
    }
    this.queryFrom.integrated_type = this.integrated_type_arr[0].value
    this.queryFrom.content_type_1 = this.integrated_type_arr[1].value
    this.queryFrom.content_type_2 = this.integrated_type_arr[2].value
    this.queryFrom.content_type_3 = this.integrated_type_arr[3].value
    this.queryFrom.unit_or_person_1 = this.unit_or_person_type_arr[0].value
    this.queryFrom.unit_or_person_2 = this.unit_or_person_type_arr2[0].value
    this.queryFrom.agent_type = this.agent_type_arr[0].value
    this.queryFrom.same_family_type = this.same_family_type_arr[0].value
    this.queryFrom.same_family2_type = this.same_family2_type_arr[0].value
    this.queryFrom.pct_type_1 = this.pct_type_arr[0].value
    this.queryFrom.pct_type_2 = this.pct_type_arr[1].value
    this.queryFrom.legal_status_type = this.legal_status_type_arr[0].value
    this.queryFrom.number_query_type_1 = this.number_query_type_arr[0].value
    this.queryFrom.number_query_type_2 = this.number_query_type_arr[1].value
    this.queryFrom.date_query_type_1 = this.date_type_arr[0].value
    this.queryFrom.date_query_type_2 = this.date_type_arr[1].value
    this.queryFrom.classification_type = this.classify_type_arr[0].value
    this.queryFrom.agent_type = this.agent_type_arr[0].value

  },
  methods: {
    getZlList(typeQuery) {
      this.queryFrom.typeQuery = typeQuery
      this.$router.push({
        name: 'zlQueryList',
        params: {
          queryFrom: JSON.stringify(this.queryFrom)
        }
      })
      // this.axios.get('/api/patentJournals/findZLByCondition', {params: this.queryFrom}).then(res => {
      // })
    }
  }
}
</script>

<style scoped>
  .query-container{
    width: 50%;
    margin: 0 auto;
    margin-top: 20px;
    padding-top: 20px;
    border: 1px solid #ccc;
  }
  .btn-box {
    text-align: right;
    margin-right: 10px;
    margin-bottom: 5px;
  }
  ::v-deep .el-form-item__label {
    margin: 0 3px 0px 0;
    display: inline-block;
    text-align: right;
    vertical-align: middle;
    font-size: 14px;
    color: #606266;
    line-height: 30.5px;
    padding: 0 7px 0 7px;
  }
  ::v-deep .el-select {
    width: 300px;
  }
</style>
